/** In-app links of the mapping-config screens. Every segment is encoded: version ids contain `#`. */

const BASE = "/admin/mapping-configs";
const seg = encodeURIComponent;

export const mappingConfigRoutes = {
  list: () => BASE,
  /** ``tab``: a config group (e.g. "llm"), "history" or "drafts"; none opens the first group. */
  plugin: (service: string, pluginId: string, tab?: string) =>
    `${BASE}/${seg(service)}/${seg(pluginId)}${tab ? `?tab=${tab}` : ""}`,
  edit: (service: string, pluginId: string, versionId: string) =>
    `${BASE}/${seg(service)}/${seg(pluginId)}/versions/${seg(versionId)}/edit`,
  review: (service: string, pluginId: string, versionId: string) =>
    `${BASE}/${seg(service)}/${seg(pluginId)}/versions/${seg(versionId)}/review`,
};
